import React from 'react'

export const Footer = () => {
	return (
		<footer className="bg-primary text-white">
			{/* Main Footer Content */}
			<div className="max-w-screen-xl mx-auto px-6 py-16">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
					{/* About & Contact Column */}
					<div className="lg:col-span-2">
						<div className="flex items-center mb-6">
							<img
								src={require('@assets/images/logo-black.png')}
								alt="Mal BOTANI SQUARE"
								className="h-10 w-auto mr-3"
							/>
						</div>
						<p className="text-white mb-6 leading-relaxed">
							Experience luxury shopping at its finest. Where premium brands
							meet exceptional service.
						</p>

						<div className="space-y-3">
							<div className="flex items-start">
								<svg
									className="w-5 h-5 text-white mt-1 mr-3 flex-shrink-0"
									fill="currentColor"
									viewBox="0 0 20 20"
								>
									<path
										fillRule="evenodd"
										d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
										clipRule="evenodd"
									/>
								</svg>
								<span className="text-white text-sm">
									Botani Square Jl. Raya Pajajaran No.40, Tugu Kujang, Kecamatan
									Bogor Tengah, Kota Bogor, Jawa Barat 16127
								</span>
							</div>

							<div className="flex items-center">
								<svg
									className="w-5 h-5 text-white mr-3 flex-shrink-0"
									fill="currentColor"
									viewBox="0 0 20 20"
								>
									<path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l.774-1.548a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
								</svg>
								<span className="text-white text-sm">
									(0251) 8386658 Customer Service
								</span>
							</div>

							<div className="flex items-center">
								<svg
									className="w-5 h-5 text-white mr-3 flex-shrink-0"
									fill="currentColor"
									viewBox="0 0 20 20"
								>
									<path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
									<path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
								</svg>
								<span className="text-white text-sm">
									info@botanisquare.com General Inquiries
								</span>
							</div>
						</div>
					</div>

					{/* Quick Links Column */}
					<div>
						<h3 className="text-lg font-bold text-white mb-6">Quick Link</h3>
						<ul className="space-y-3">
							{['Directory', 'Promotion', 'Event', 'Article'].map(link => (
								<li key={link}>
									<a
										href={`/${link.toLowerCase()}`}
										className="text-white hover:text-gray-100 transition-colors duration-200 flex items-center group"
									>
										<svg
											className="w-4 h-4 text-white mr-2 group-hover:translate-x-1 transition-transform duration-200"
											fill="currentColor"
											viewBox="0 0 20 20"
										>
											<path
												fillRule="evenodd"
												d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
												clipRule="evenodd"
											/>
										</svg>
										{link}
									</a>
								</li>
							))}
						</ul>
					</div>

					{/* Customer Services Column */}
					<div>
						<h3 className="text-lg font-bold text-white mb-6">
							Customer Services
						</h3>
						<ul className="space-y-3">
							<li>
								<a
									href="https://wa.me/6281277774798"
									target="_blank"
									rel="noreferrer"
									className="text-white hover:text-gray-100 transition-colors duration-200 flex items-center group"
								>
									<svg
										className="w-4 h-4 text-white mr-2 group-hover:translate-x-1 transition-transform duration-200"
										fill="currentColor"
										viewBox="0 0 20 20"
									>
										<path
											fillRule="evenodd"
											d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
											clipRule="evenodd"
										/>
									</svg>
									Contact Us
								</a>
							</li>
						</ul>

						<div className="mt-8">
							<h4 className="text-lg font-bold text-white mb-4">
								Operating Hours
							</h4>
							<div className="space-y-2 text-white text-sm">
								<p>Monday - Saturday</p>
								<p className="font-medium">10:00 AM - 09:00 PM</p>
								<p>Sunday</p>
								<p className="font-medium">10:00 AM - 10:00 PM</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Bottom Footer Bar */}
			<div className="border-t border-primary-dark">
				<div className="max-w-screen-xl mx-auto px-6 py-6">
					<div className="flex flex-col md:flex-row justify-between items-center">
						{/* Copyright */}
						<div className="text-white text-sm mb-4 md:mb-0">
							© 2025 Botani Square. All rights reserved. |
							<a
								href="/privacy-policy"
								className="hover:text-gray-100 transition-colors duration-200 ml-1"
							>
								Privacy Policy
							</a>
						</div>

						{/* Social Media */}
						<div className="flex items-center space-x-4">
							<span className="text-white text-sm">Follow us:</span>
							<div className="flex space-x-3">
								<a
									href="https://www.instagram.com/botanisquaremall"
									target="_blank"
									rel="noreferrer"
									aria-label="Instagram"
									className="text-white hover:text-gray-100 transition-colors duration-200"
								>
									<svg
										className="w-5 h-5"
										fill="currentColor"
										viewBox="0 0 24 24"
									>
										<path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.336 3.608 1.311.975.975 1.249 2.242 1.311 3.608.058 1.266.069 1.646.069 4.85s-.012 3.584-.069 4.85c-.062 1.366-.336 2.633-1.311 3.608-.975.975-2.242 1.249-3.608 1.311-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.336-3.608-1.311-.975-.975-1.249-2.242-1.311-3.608C2.175 15.747 2.163 15.367 2.163 12s.012-3.584.07-4.85c.062-1.366.336-2.633 1.311-3.608.975-.975 2.242-1.249 3.608-1.311C8.416 2.175 8.796 2.163 12 2.163zm0 1.838c-3.155 0-3.507.012-4.745.067-1.005.046-1.547.213-1.91.354-.48.187-.823.41-1.183.77-.36.36-.583.703-.77 1.183-.141.363-.308.905-.354 1.91-.055 1.238-.067 1.59-.067 4.745s.012 3.507.067 4.745c.046 1.005.213 1.547.354 1.91.187.48.41.823.77 1.183.36.36.703.583 1.183.77.363.141.905.308 1.91.354 1.238.055 1.59.067 4.745.067s3.507-.012 4.745-.067c1.005-.046 1.547-.213 1.91-.354.48-.187.823-.41 1.183-.77.36-.36.583-.703.77-1.183.141-.363.308-.905.354-1.91.055-1.238.067-1.59.067-4.745s-.012-3.507-.067-4.745c-.046-1.005-.213-1.547-.354-1.91-.187-.48-.41-.823-.77-1.183-.36-.36-.703-.583-1.183-.77-.363-.141-.905-.308-1.91-.354C15.507 4.013 15.155 4.001 12 4.001zm0 3.13a4.87 4.87 0 110 9.738 4.87 4.87 0 010-9.738zm0 8.034a3.165 3.165 0 100-6.33 3.165 3.165 0 000 6.33zm6.182-8.235a1.137 1.137 0 11-2.274 0 1.137 1.137 0 012.274 0z" />
									</svg>
								</a>
								<a
									href="https://www.tiktok.com/@botanisquaremall"
									target="_blank"
									rel="noreferrer"
									aria-label="TikTok"
									className="text-white hover:text-gray-100 transition-colors duration-200"
								>
									<svg
										className="w-5 h-5"
										fill="currentColor"
										viewBox="0 0 24 24"
									>
										<path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 3.32.98.31 2.03.12 2.9-.42.87-.53 1.44-1.38 1.68-2.35.32-1.24.32-2.56.31-3.89V8.46c.76.01 1.52.02 2.28.01.01-.84.01-1.68.01-2.52z" />
									</svg>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	)
}
